import React from 'react'
import styled from 'styled-components'

const FloorRoomPrompt = ({children}) => {
  return (
    <Container>
      <StyledPrompt>{children}</StyledPrompt>
    </Container>
  )
}

export default FloorRoomPrompt

const Container = styled.div`
  display: flex;
  align-content: center;
  flex: 1;
  border-radius: 8px;
  background: white;
  box-sizing: border-box;
`

const StyledPrompt = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
`
